import { API_URL } from '../config';
import { makeApiCall } from '../_common/api.utils';

export const resetPassword = async (data: any) => {
	const URL = `${API_URL}ResetPassword`;
	console.log('API URL:', URL);

	console.log('Request payload (encrypted):', data);
	const requestData = {
		ResetPasswordToken: data, // Use capital R and P to match backend expectation
	};
	return makeApiCall(URL, requestData);
};

export const resetFingerprint = async (data: any) => {
	const URL = `${API_URL}ResetDeviceFingerprint`;
	console.log('API URL:', URL);

	console.log('Request payload (encrypted):', data);
	const requestData = {
		ResetDeviceFingerprintToken: data, // Use correct key name to match backend expectation
	};
	return makeApiCall(URL, requestData);
};
